import { Col } from 'components-antd';
import styles from './styles.module.scss';
import React from 'react';
import classNames from 'classnames';

type ModalRightSectionsType = {
  children: React.ReactNode;
  className?: string;
};

export const ModalRightSection = (props: ModalRightSectionsType) => {
  const { className, children } = props;
  return (
    <Col lg={12} md={24} sm={24} xs={24} className={classNames(styles.rightSection, className)}>
      {children}
    </Col>
  );
};
